module.exports = __webpack_public_path__ + "media/images/emoticons/sprinkle-8760ca9a232e7374d7824ef2c0845b43.gif";